import type { SyntheticEvent } from 'react';

/**
 * onPlay handler for <audio controls> preview lists (drawer Sounds tab,
 * Library manager): starting one preview pauses every other audio element
 * on the page so two sounds never play over each other.
 */
export function pauseOtherAudio(e: SyntheticEvent<HTMLAudioElement>) {
   const current = e.currentTarget;
   document.querySelectorAll('audio').forEach((el) => {
      if (el !== current && !el.paused) el.pause();
   });
}
